import { isMobile as isMobileJudge } from "react-device-detect";

/* PC or スマホ＆タブレットの判定(null===PC) */
export const isMobile = () => {
  return isMobileJudge;
};
